






import { Component, Prop, Vue } from 'vue-property-decorator';
import ITab from './ITab';

@Component({
    name: 'Tab'
})
export default class Tab extends Vue implements ITab {
	@Prop({ type: String, required: true }) name!: string;
	@Prop({ type: Boolean, required: false, default: false }) selected!: boolean;

	active: boolean = this.selected;

	public toggle(active: boolean) {
	    this.active = active;
	}

	public get isActive() {
	    return this.active;
	}
}
